import { ErrorResolution } from '../../app/common/errorResolution/errorResolution';
import { IMemberInfo } from './cancelMemberState';

export enum CancelMembershipActionType {
    CANCEL_MEMBERSHIP_START = 'CANCEL_MEMBERSHIP_START',
    CANCEL_MEMBERSHIP_REQUEST = 'CANCEL_MEMBERSHIP_REQUEST',
    CANCEL_MEMBERSHIP_SUCCESS = 'CANCEL_MEMBERSHIP_SUCCESS',
    CANCEL_MEMBERSHIP_FAILURE = 'CANCEL_MEMBERSHIP_FAILURE',

    CLOSE_CANCEL_MEMBERSHIP_OVERLAY = 'CLOSE_CANCEL_MEMBERSHIP_OVERLAY',
    OPEN_CANCEL_MEMBERSHIP_OVERLAY = 'OPEN_CANCEL_MEMBERSHIP_OVERLAY',

    CLOSE_CANCEL_MEMBERSHIP_PAGE = 'CLOSE_CANCEL_MEMBERSHIP_PAGE',
}

export type CancelMembershipAction =
    | {
          type: CancelMembershipActionType.CANCEL_MEMBERSHIP_REQUEST;
          payload: { member: IMemberInfo };
      }
    | {
          type: CancelMembershipActionType.CANCEL_MEMBERSHIP_SUCCESS;
          payload: {};
      }
    | {
          type: CancelMembershipActionType.CANCEL_MEMBERSHIP_FAILURE;
          payload: { errorResolution: ErrorResolution };
      }
    | {
          type: CancelMembershipActionType.CLOSE_CANCEL_MEMBERSHIP_OVERLAY;
          payload: {};
      }
    | {
          type: CancelMembershipActionType.OPEN_CANCEL_MEMBERSHIP_OVERLAY;
          payload: {};
      }
    | {
          type: CancelMembershipActionType.CANCEL_MEMBERSHIP_START;
      }
    | {
          type: CancelMembershipActionType.CLOSE_CANCEL_MEMBERSHIP_PAGE;
      };
